module.exports = __webpack_public_path__ + "hex.a57c0bf6c2228581fc93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hex.jpg
// module id = ./src/assets/hex.jpg
// module chunks = main